import { XeroFetchedAccountDto } from "@libs/gateways/custom-integration/CustomIntegrationXeroGateway.dtos.ts";

export const displayOptions = (
  fetchedAccount: XeroFetchedAccountDto[],
  filterFn: (x: XeroFetchedAccountDto) => boolean | undefined
) =>
  fetchedAccount.filter(filterFn).map(x => ({
    key: x.id,
    text: x.name ?? ""
  }));
